module.exports = require("./fr-BJ.js");